import React from "react";
import { AiOutlineDownload } from "react-icons/ai";


export default class DownloadTable extends React.Component {
  
    constructor(props) {
        super(props);
        this.url = props.url;
        this.table_name = props.table_name;
    }

    render() {        
        return (

            <a className="download-table" href={this.url}>
                <AiOutlineDownload/>
                <p>Download {this.table_name}</p>
            </a>

        )
    }
}
